import { JSX } from 'react';
import { useQueryMe } from '../hooks/auth';
import ErrorPage from './errorPage';
import PageLoader from './pageLoader';

interface PrivateRouteProps {
  element: JSX.Element;
}

/**
 * Require auth before render component (element property)
 */
const PrivateRoute = ({ element }: PrivateRouteProps): JSX.Element => {
  // Initiate loading auth data
  const { isLoading, isError } = useQueryMe();

  if (isLoading) {
    return <PageLoader />;
  }

  if (isError) {
    return <ErrorPage />;
  }

  return element;
};

export default PrivateRoute;
